module.exports = __webpack_public_path__ + "img/top-bar.d350ff8b.png";